module.exports = __webpack_public_path__ + "img/empty_section.5000e28e.png";